import React from "react";
import AmCharts from "@amcharts/amcharts3-react";
import { Typography } from "material-ui";

const fakeData = [
  {
    Tiempo: 50,
    Unidad: "TRA 01"
  },
  {
    Tiempo: 40,
    Unidad: "TRA 02"
  },
  {
    Tiempo: 60,
    Unidad: "TRA 03"
  },
  {
    Tiempo: 10,
    Unidad: "TRA 04"
  },
  {
    Tiempo: 70,
    Unidad: "TRA 05"
  },
  {
    Tiempo: 55,
    Unidad: "TRA 06"
  },
  {
    Tiempo: 11,
    Unidad: "TRA 07"
  },
  {
    Tiempo: 5,
    Unidad: "TRA 08"
  },
  {
    Tiempo: 4,
    Unidad: "TRA 09"
  },
  {
    Tiempo: 100,
    Unidad: "TRA 10"
  },
  {
    Tiempo: 3,
    Unidad: "TRA 11"
  },
  {
    Tiempo: 80,
    Unidad: "TRA 12"
  }
];

const RalentiTile = props => {
  const { data } = props;

  return (
    <div className="dashboard-tile">
      <div className="tile-header">
        <Typography
          variant="title"
          align="center"
          color="primary"
          className="headline"
        >
          Ralentí
        </Typography>
      </div>
      <div className="tile-chart-body">
        <RalentiChart data={fakeData} />
      </div>
    </div>
  );
};

const RalentiChart = ({ data }) => {
  const config = {
    type: "serial",
    theme: "light",
    dataProvider: data.sort((a, b) => (a.Tiempo >= b.Tiempo ? false : true)),
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        position: "left",
        title: "Minutos"
      }
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]]</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "Tiempo"
      }
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryField: "Unidad",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20
    },
    export: {
      enabled: true
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "100%",
        fontSize: "10px"
      }}
      options={config}
    />
  );
};

export default RalentiTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/RalentiTile.js